import { BreadcrumbsType } from '@/lib/getBreadcrumbs';
import Link from 'next/link';

type BreadcrumbProps = {
    breadcrumbs?: BreadcrumbsType[];
    showBreadcrumbs?: boolean;
    className?: string;
};

export function Breadcrumb({ breadcrumbs, showBreadcrumbs, className }: BreadcrumbProps) {
    if (!showBreadcrumbs || !breadcrumbs || !breadcrumbs.length) {
        return null;
    }

    return (
        <div className={className}>
            <ul className="list-none flex flex-row">
                {breadcrumbs.map((item, index) => {
                    return (
                        <li key={`${index}-${item.title}`} className="text-white text-base font-bold" style={{ textShadow: '0 4px 4px rgba(0,0,0,0.25)' }}>
                            {index !== 0 && <span className="px-3">/</span>}
                            <Link href={item.url} className="hover:underline">
                                {item.title}
                            </Link>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}
